import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { routes } from 'app/routes'
import { Login } from './screens/Login'
import { Dashboard } from './screens/Dashboard'
import { UserInvite } from './screens/UserInvite'
import { PrivateRoute } from './PrivateRoute'
import { PageNotFound } from './screens/PageNotFound'
import { Profile } from './screens/Profile'
import { ProfileEdit } from './screens/ProfileEdit'
import { ForgotPassword } from './screens/ForgotPassword'
import { ResetPassword } from './screens/ResetPassword'

export const AppRouter: React.FC = () => {
  return (
    <Switch>
      <Route exact path={routes.login.path}>
        <Login />
      </Route>
      <Route exact path={routes.userInvite.path}>
        <UserInvite />
      </Route>
      <Route exact path={routes.forgotPassword.path}>
        <ForgotPassword />
      </Route>
      <Route exact path={routes.resetPassword.path}>
        <ResetPassword />
      </Route>
      <PrivateRoute exact path={routes.dashboard.path}>
        <Dashboard />
      </PrivateRoute>
      <PrivateRoute exact path={routes.quotation.path}>
        <Dashboard />
      </PrivateRoute>
      <PrivateRoute exact path={routes.profile.path}>
        <Profile />
      </PrivateRoute>
      <PrivateRoute exact path={routes.editProfile.path}>
        <ProfileEdit />
      </PrivateRoute>
      <Route path='*'>
        <PageNotFound />
      </Route>
    </Switch>
  )
}
